import React, {Component} from 'react';
import FeedbackService from '../../services/FeedbackService';
import './Feedback.css';
import { connect } from 'react-redux';

class Estrela extends Component {

    clique = () => {
        this.props.callback(this.props.limite)
    }
    
    render() {
        return (
            <img alt="estrela" onClick={this.clique} style={{maxWidth:'40px', margin:'0.4em'}} src={this.props.valor >= this.props.limite ? "/star_full.png" : "/star_empty.png"}/>
        )
    }
}

class Estrelas extends Component {
    
    render() {
        return (
        <div>
            <Estrela limite="1" valor={this.props.valor} callback={this.props.callback}/>
            <Estrela limite="2" valor={this.props.valor} callback={this.props.callback}/>
            <Estrela limite="3" valor={this.props.valor} callback={this.props.callback}/>
            <Estrela limite="4" valor={this.props.valor} callback={this.props.callback}/>
            <Estrela limite="5" valor={this.props.valor} callback={this.props.callback}/>
        </div>
        )
    }
}

class SimNao extends Component {

    clique = (valor) => {
        this.props.callback(valor)
    }

    render() {
        return (
            <div>
                <img alt="Sim" onClick={() => {this.clique(true)}} src={this.props.valor === true ? '/sim_enabled.png' : '/sim_disabled.png'} style={{marginRight:'1.0em'}}/>
                
                <img alt="Não" onClick={() => {this.clique(false)}} src={this.props.valor === false ? '/nao_enabled.png' : '/nao_disabled.png'}/>
            </div>
        )
    }
}

class Feedback extends Component {

    state = {
        processando:false,
        enviado:false,
        feedback:{
            conteudoRelevante:0,
            recomendaria:0,
            participariaNovamente:null,
            mensagem:""
        }
    }

    onChangeConteudoRelevante = (estrelas) => {
        let feedback = this.state.feedback
        feedback.conteudoRelevante = estrelas
        this.setState({feedback:feedback})
    }

    onChangeRecomendaria = (estrelas) => {
        let feedback = this.state.feedback
        feedback.recomendaria = estrelas
        this.setState({feedback:feedback})
    }

    onChangeParticiparia = (valor) => {
        let feedback = this.state.feedback
        feedback.participariaNovamente = valor
        this.setState({feedback:feedback})
    }

    onChangeFeedback = (valor) => {
        let feedback = this.state.feedback
        feedback.mensagem = valor.target.value
        this.setState({feedback:feedback})
    }

    enviar = () => {
        let feedback = this.state.feedback
        if (feedback.participariaNovamente === null || 
            feedback.recomendaria === 0 || 
            feedback.conteudoRelevante === 0) {
                return
            }
        this.setState({processando:true})
        let service = new FeedbackService()
        service.enviarFeedback(feedback, (erro, sucesso) => {
            this.setState({processando:false, enviado:(erro === null)})
        })
        
    }

    voltar = () => {
        this.props.history.push("/atividades")
    }

    render() {
        
        const resposta = this.state.feedback
        const enviado = this.state.enviado
        const i18n = this.props.i18n;

        if (enviado) {
            return (
                <div className="card weex-card-interno weex-card-feedback">
                
                <div style={{borderRadius:'30px'}} className="conteudo-card-atividades conteudo-card-atividades-feedback">
                    <div style={{textAlign:'center', marginTop:'2.0em'}}>
                        <img alt="Obrigado" src="/obrigado_feedback.png" style={{width:'70%'}}/>
                    </div>
                    <div className="questao_feedback" style={{marginTop:'2.0em'}}>
                    <a className="weex-button" onClick={this.voltar}>{i18n.message("geral.voltar", "Voltar")}</a>
                    </div>
                </div>
            </div>
            )
        }
        return (
            <div className="card weex-card-interno weex-card-feedback">
                <header className="card-header" style={{marginBottom:'1.0em'}}>
                        <div className="card-header-title weex-card-header card-header-feedback" style={{paddingTop:'0.9em', paddingBottom: '0.9em'}}>
                            <p>{i18n.message("feedback.titulo1", "Conte-nos sobre sua experiência aqui.")}</p>
                            <p>{i18n.message("feedback.titulo2", "Sua opinião é fundamental!")}</p>
                        </div>
                </header>
                <div className="conteudo-card-atividades conteudo-card-atividades-feedback">
                    <div className="questao_feedback">
                        <p className="questao_feedback_enunciado">{i18n.message("feedback.questao1", "O conteúdo foi relevante?")}</p>
                        <Estrelas valor={resposta.conteudoRelevante} callback={this.onChangeConteudoRelevante}/>
                    </div>
                    <div className="questao_feedback">
                        <p className="questao_feedback_enunciado">{i18n.message("feedback.questao2", "Você recomendaria para algum colega?")}</p>
                        <Estrelas valor={resposta.recomendaria} callback={this.onChangeRecomendaria}/>
                    </div>
                    <div className="questao_feedback">
                        <p className="questao_feedback_enunciado">{i18n.message("feedback.questao3", "Você participaria novamente?")}</p>
                        <SimNao valor={resposta.participariaNovamente} callback={this.onChangeParticiparia}/>
                    </div>
                    <div className="questao_feedback">
                        <p className="questao_feedback_enunciado">{i18n.message("feedback.comentarios", "Escreva seus comentários (opcional)")}</p>
                        <textarea value={resposta.mensagem} 
                                  onChange={this.onChangeFeedback} 
                                  style={{'padding':'14px', 'width':'95%', 'borderRadius':'10px', 'border':'solid 1px #dedede'}} 
                                  rows="5" maxLength="250"/>

                        <div style={{width:'100%', 'textAlign':'right', 'paddingRight':'14px', 'paddingTop':'0', 'marginTop':'0'}}><span style={{'fontSize':'0.8em','color':((250 - resposta.mensagem.length <= 20 ? 'red' : 'black'))}}>{resposta.mensagem ? resposta.mensagem.length : 0}/250</span></div>
                    </div>
                    <div className="questao_feedback" style={{marginTop:'2.0em'}}>
                    <a className="weex-button" onClick={this.enviar}>{this.state.processando ? i18n.message("geral.aguarde", 'Aguarde...') : i18n.message("geral.enviar", 'Enviar') }</a>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = function(state) {
    return {
        i18n:state.i18n
    }
}

export default connect(mapStateToProps)(Feedback)